module.exports = __webpack_public_path__ + "img/gb-whatsapp-risks.b41cd2dc.webp";